import {
    Divider,
    IconCallLandlineRegular,
    IconFusionRegular,
    IconMobileDeviceRegular,
    IconTimeRegular,
    Text1,
    Text2,
    skinVars,
} from '@telefonica/mistica';
import { PortabilityInfos } from '../../models/Orders';
import './index.scss';
import { t } from 'i18next';
import dayjs from 'dayjs';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';

export const PortabilityInfoSection = ({ portabilityInfos }: { portabilityInfos: PortabilityInfos[] }) => {
    return (
        <div className='portabilityInfo-component'>
            <div className='portabilityInfo-component__title'>
                <IconFusionRegular size={24} color={skinVars.colors.textSecondary} />
                <div className='portabilityInfo-component__title-text'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('portabilityInfoTitle')}
                    </Text1>
                </div>
            </div>

            <div className='portabilityInfo-component__content'>
                {portabilityInfos.map((item, index) => (
                    <div className='portabilityInfo-component__content-section' key={index}>
                        <div className='portabilityInfo-component__content-section-number'>
                            {item.number.slice(0, 1) === '6' ? (
                                <IconMobileDeviceRegular size={24} color={skinVars.colors.brandHigh} />
                            ) : (
                                <IconCallLandlineRegular
                                    size={24}
                                    color={skinVars.colors.brandHigh}
                                    style={{ transform: 'rotate(90deg)' }}
                                />
                            )}

                            <div className='portabilityInfo-component__content-section-number-text'>
                                <Text2 regular>{formatMobileNumber(item.number)}</Text2>
                            </div>
                        </div>
                        <div className='portabilityInfo-component__content-section-status'>
                            <IconTimeRegular size={24} color={skinVars.colors.brandHigh} />
                            <div className='portabilityInfo-component__content-section-status-text'>
                                <Text2 regular>{item.status}</Text2>
                            </div>
                        </div>
                        <div className='portabilityInfo-component__content-section-date'>
                            <Text2 regular color={skinVars.colors.textSecondary}>
                                {t('portabilityInfoDateTitle')}
                            </Text2>
                            <div className='portabilityInfo-component__content-section-date-text'>
                                <Text2 regular>{dayjs(item.date).format('DD/MM/YYYY')}</Text2>
                            </div>
                        </div>

                        <div className='portabilityInfo-component__content-section-divider'>
                            <Divider />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
